import { render, staticRenderFns } from "./SevenTeenTable.vue?vue&type=template&id=a21d1f08&"
import script from "./SevenTeenTable.vue?vue&type=script&lang=js&"
export * from "./SevenTeenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports